module.exports = __webpack_public_path__ + "static/img/jiuzhu.763e1694.png";